import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsFormConfig } from '../../models/appliance-details/appliance-details-form-config.interface';
import { mockApplianceDetailsFormValue } from './appliance-details-form-value.mock';
import { mockCmsApplianceDetailsForm } from './cms-appliance-details-form.mock';

export const mockApplianceDetailsFormConfig: ApplianceDetailsFormConfig = {
  applianceMaximumAge: new Date(),
  clientBrandCode: ClientBrandCode.Beko,
  cmsData: mockCmsApplianceDetailsForm,
  initialValue: mockApplianceDetailsFormValue,
};
